import camelcaseKeys from "camelcase-keys";

import { env as envClient } from "@/common/env/client.mjs";
import { env as envServer } from "@/common/env/server.mjs";

export const getCmsAssetUrl = (path: string) =>
  `${envClient.NEXT_PUBLIC_CMS_ASSETS_URL || "/not-defined-cms-assets-url"}/${path}`;

// Use only to get images from PRODUCTION CMS! For another assets use getCmsAssetUrl()
export const getCmsImagesUrl = (path: string) =>
  `${envClient.NEXT_PUBLIC_CMS_IMAGES_URL || "/not-defined-cms-images-url"}/${path}`;

export const serialize = (data: unknown) =>
  typeof data === "object" && data !== null ? camelcaseKeys(data, { deep: true }) : data;

export const getCmsUrl = (path: string) => `${envClient.NEXT_PUBLIC_CMS_BASE_URL}${path}`;
export const getCmsAuthorizationHeader = () => `Bearer ${envServer.CMS_API_TOKEN}`;
export const getCmsAuthorizationHeaderObject = () => ({ Authorization: getCmsAuthorizationHeader() });
